<template>
  <div class="hero-banner md:my-2 lg:my-3 md:rounded-xl border-gray-400 shadow">
    <div class="hero-content">
      <div class="hero-top-row">
        <div class="hero-text">
          <h1 class="hero-greeting">
            {{ greet }}, <span class="user-highlight">{{ user.split(" ")[0] }}</span>
          </h1>
          <p class="hero-date">
            {{ formattedDate }}
          </p>
        </div>
        <WeatherComponent />
      </div>
    </div>
  </div>
</template>

<script>
import * as datefns from "date-fns"
import WeatherComponent from "@/views/Dashboard/components/WeatherComponent.vue"

export default {
  name: "DailyGreeting",
  components: {
    WeatherComponent,
  },
  props: {
    user: {
      type: String
    },
  },
  computed: {
    greet(){
      let hrs = datefns.getHours(Date.now())
      let greet
      if (hrs < 12)
        greet = 'Good morning'
      else if (hrs >= 12 && hrs <= 17)
        greet = 'Good afternoon'
      else if (hrs >= 17 && hrs <= 24)
        greet = 'Good evening'
      return greet
    },
    formattedDate() {
      return datefns.format(new Date(), "EEEE, MMMM do, yyyy")
    }
  }
}
</script>

<style scoped>
.hero-banner {
  position: relative;
  overflow: hidden;
  /* background: linear-gradient(90deg, #3a559e 0%, #3a559e 5%, #4052a0 40%, #4c6abd 100%); */
  /* background: linear-gradient(135deg, #ecf2f6, #ebf1f4); */
  /* background: linear-gradient(90deg, #262c3d 0%, #1d222fd4 5%, #1b1d2ab2 40%, #2f38517d 100%); */
  /* The "Soft Tech" Base: A very light, clean gradient */
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  padding: 2rem 2.5rem;
  border-color: rgba(226, 232, 240, 0.8);
}

.hero-content {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  max-width: 1280px;
  margin: 0 auto;
  animation: hero-fade-in 0.8s cubic-bezier(0.16, 1, 0.3, 1) both;
}

.hero-top-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.hero-text {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.hero-greeting {
  font-size: 1.75rem;
  font-weight: 800;
  color: #1e293b;
  letter-spacing: -0.02em;
  line-height: 1.2;
  margin: 0;
  text-align: left;
}

/* Adding a pop of color to the name */
.user-highlight {
  color: #0092bf;
}

.hero-date {
  font-size: 0.875rem;
  font-weight: 600;
  color: #64748b;
  margin-top: 0.5rem;
  text-align: left;
  letter-spacing: 0.05em;
}

/* Ambient decorative orbs */
.hero-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  opacity: 0.4;
  pointer-events: none;
}
.hero-orb--1 {
  width: 350px;
  height: 350px;
  background: radial-gradient(circle, #bae6fd 0%, #7dd3fc 100%); /* Soft Sky Blue */
  top: -150px;
  right: -50px;
  animation: orb-drift 12s ease-in-out infinite alternate;
}
.hero-orb--2 {
  width: 40%;
  height: 100%;
  background: radial-gradient(circle, #baeefd 0%, #7dd3fc 100%); /* Soft Teal */
  bottom: 100px;
  left: -5%;
  animation: orb-drift 15s ease-in-out infinite alternate-reverse;
}
.hero-orb--3 {
  width: 200px;
  height: 200px;
  background: radial-gradient(circle, #e0e7ff 0%, #c7d2fe 100%); /* Soft Indigo */
  top: 20%;
  left: 40%;
  opacity: 0.2;
  animation: orb-drift 20s linear infinite;
}

@keyframes hero-fade-in {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes orb-drift {
  0% { transform: translate(0, 0) scale(1); }
  100% { transform: translate(20%, -50%) scale(1.1); }
}

@media (max-width: 768px) {
  .hero-banner {
    padding: 1.5rem 1.25rem;
  }
  .hero-top-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
  .hero-greeting {
    font-size: 1.35rem;
  }
}

/* ── Dark mode ─────────────────────────────────── */
:root[data-theme="dark"] .hero-banner {
  background: linear-gradient(135deg, rgba(15, 20, 35, 0.6), rgba(25, 35, 60, 0.5));
  border-color: rgba(255, 255, 255, 0.06);
}
:root[data-theme="dark"] .hero-greeting {
  color: rgba(255, 255, 255, 0.90);
}
:root[data-theme="dark"] .user-highlight {
  color: #00d4ff;
  text-shadow: 0 0 20px rgba(0, 212, 255, 0.3);
}
:root[data-theme="dark"] .hero-date {
  color: rgba(255, 255, 255, 0.50);
}
</style>